import React from "react";

const Breadcrumb = ({ title, breadcrumbs, breadcrumbBg }) => {
  return (
    <div
      className={`rts-breadcrumb-area ${
        breadcrumbBg ? "" : "breadcrumb-bg"
      } bg_image`}
      style={breadcrumbBg ? { backgroundImage: `url(${breadcrumbBg})` } : {}}
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 breadcrumb-1"
            style={{
              backgroundColor: "#F2F2F240",
              padding: "10px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              wordBreak: "break-word",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              hyphens: "auto",
            }}
          >
            <h1
              className="title"
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                hyphens: "auto",
                margin: 0,
                textAlign: "center",
              }}
            >
              {title}
            </h1>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div
              className="bread-tag"
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                flexWrap: "wrap",
                gap: "4px",
              }}
            >
              {breadcrumbs.map((breadcrumb, index) => (
                <span
                  key={index}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {breadcrumb.link ? (
                    <a
                      href={breadcrumb.link}
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {breadcrumb.label}
                    </a>
                  ) : (
                    <span
                      className="active"
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {breadcrumb.label}
                    </span>
                  )}
                  {index < breadcrumbs.length - 1 && (
                    <span style={{ margin: "0 4px", whiteSpace: "nowrap" }}>
                      {" "}
                      /{" "}
                    </span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`
                @media (max-width: 767px) {
                    .rts-breadcrumb-area .bread-tag {
                        flex-wrap: wrap !important;
                        justify-content: center !important;
                        padding: 12px 20px !important;
                        text-align: center;
                    }
                    .rts-breadcrumb-area .bread-tag span {
                        white-space: normal !important;
                        display: inline !important;
                    }
                    .rts-breadcrumb-area .bread-tag a,
                    .rts-breadcrumb-area .bread-tag .active {
                        white-space: normal !important;
                        word-break: break-word !important;
                        overflow-wrap: break-word !important;
                    }
                }
                @media (max-width: 480px) {
                    .rts-breadcrumb-area .bread-tag {
                        padding: 10px 15px !important;
                        font-size: 14px;
                    }
                }
            `}</style>
    </div>
  );
};

export default Breadcrumb;
